var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.79446 6.70538C9.40519 7.09466 9.40484 7.72569 9.79369 8.11538L12.965 11.2937C13.3545 11.684 13.3545 12.316 12.965 12.7063L9.79369 15.8846C9.40484 16.2743 9.40519 16.9053 9.79446 17.2946C10.184 17.6842 10.8157 17.6842 11.2052 17.2946L15.7927 12.7071C16.1833 12.3166 16.1833 11.6834 15.7927 11.2929L11.2052 6.70538C10.8157 6.31581 10.184 6.31581 9.79446 6.70538Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.7dad367f4994c7f4b8586d56f4c410ba.svg";
export { ForwardRef as ReactComponent };